import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";
 
import
{ Mensaje } from '../components/mensajes';
import axios from "axios";


import {Dimmer} from "../components/spinner";
const CatalogoOrganismot = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [valor, setValor] = useState(0.00);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'NOMBRE', textAlign: 'center' },
        { label: 'RIF', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "")
                    return items;
                else
                    return items.filter(x => {

                        if ((x.razon !== null ? x.razon.toLowerCase().includes(target.value.toLowerCase()):'')
                            || (x.rif !== null ? x.rif.toLowerCase().includes(target.value.toLowerCase()) : '')
                        ) {
                            return x;
                        }
                    });
            }
        })

    }

    const seleccionarRegistros = () => {

        setActivate(true);

        let campos = "*"
        let nomtab = "proveedor";
        let nomid = "tipo";

        let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${'4'}&nomtab=${nomtab}&nomid=${nomid}`

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);
                var datos = []
                for (let i = 0; i < response.data.length; i++) {
                    datos.push({
                        id: response.data[i].idproveedor,
                        razon: response.data[i].razonsocial,
                        dencomer: response.data[i].denominacioncomercial,
                        direccion: response.data[i].direccion,
                        rif: response.data[i].rif,
                        tipo: response.data[i].tipo,
                    })
                }
                setRecords(datos)
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const seleccionarClassPresupuestaria = () => {
        blanquear();
        props.onHideAceptaOrganismo(values.id, values.razon, values.direccion, values.rif, values.dencomer, values.tipo);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setActivo(false);
        setItemSelect(index);

        setValues({
            id: recordsAfterPagingAndSorting()[index].id,
            razon: recordsAfterPagingAndSorting()[index].razon,
            direccion: recordsAfterPagingAndSorting()[index].direccion,
            rif: recordsAfterPagingAndSorting()[index].rif,
            dencomer: recordsAfterPagingAndSorting()[index].dencomer,
            tipo: recordsAfterPagingAndSorting()[index].tipo,
        });

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarRegistros()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>Cuentas Presupuestarias</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input type='text'
                            onChange={handleSearch} className="form-control rounded-pill search-input" />
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-left' style={{ width: '300px' }}>{item.razon}</td>
                                        <td className='py-2 text-center' style={{ width: '50px' }}>{item.rif}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={seleccionarClassPresupuestaria}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoOrganismot;